import React from 'react';
import {Container, Title} from './styles'

const Header = () => {
    return (
        <Container>
            <Title>Dinossour Games</Title>
        </Container>
    );
};

export default Header;